import React from "react";
import { Empty } from "antd";
import { EmptyProps } from "antd/lib/empty";

const EmptyComponent = (props: EmptyProps) => {
  const {  style } = props;
  return <Empty  {...props} style={{ margin: "8px", ...style }} />;
};

export default EmptyComponent;
